import { React, useState, useEffect } from "react";
import "./Home.css";
import Info1 from "../../components/InfoBlocks/Inforblocks1/Info";
import Info2 from "../../components/InfoBlocks/Inforblocks2/Info";
import Info3 from "../../components/InfoBlocks/Inforblocks3/Info";
import Info4 from "../../components/InfoBlocks/Inforblocks4/Info";
import Info5 from "../../components/InfoBlocks/Inforblocks5/Info";
import flag from "../../images/flag.png";
import azadi from "../../images/home-page-azadi.png";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
// import required modules
import { Autoplay, Navigation, EffectFade } from "swiper";
import "swiper/css/effect-fade";
import { getAllImages } from "../../services/Api";

const Home = () => {

  const [today, setToday] = useState(new Date().getDate());
  const [images, setImages] = useState();
  const getImages = async (uid) => {
    const data = await getAllImages(uid);
    setImages(data.data.data);
    console.log(images);
  };
  
  useEffect(() => {
    const data = JSON.parse(window.localStorage.getItem("user"));
    console.log(data);
    getImages(data?.uid);
  }, []);
  
  return (
    <div className="home-container">
      <div className="head-container">
        <div className="text head-child">
          <div className="text-head-heading">Work life Balance & Sustainable Environment</div>
          <div className="text1">
          On this Environment Day, A sustainable environment is a crucial aspect of our collective future. It encompasses practices that protect and preserve natural resources, reduce waste and emissions, promote renewable energy, and foster biodiversity. However, achieving sustainability requires a collective effort, and work-life balance plays a pivotal role in this endeavor. 
          </div>
          <div className="text2">
          To achieve work-life balance and contribute to a sustainable environment, there are several practical steps we can take. Firstly, it is important to set boundaries and prioritize self-care. This means allocating time for activities that promote physical and mental well-being, such as exercise, hobbies, spending time with loved ones, and disconnecting from work-related devices. 
          </div>
          {/* <div className="text3">
            The official journey of Azadi Ka Amrit Mahotsav commenced on 12th
            March 2021 which started a 75-week countdown to our 75th anniversary
            of independence and will end post a year on 15th August 2023.
            Following are the five themes of Azadi Ka Amrit Mahotsav.
          </div> */}
        </div>

        {images?.length ? (
          <div className="image head-child">
            <Swiper
              spaceBetween={30}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              navigation={true}
              modules={[Autoplay, Navigation]}
              className="mySwiper swiper-fixed-width-500"
            >
              {images.map((elem) => (
                <SwiperSlide
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  data-swiper-autoplay="2000"
                >
                  <img
                    className="slider-img"
                    src={`https://missionlife.iiita.ac.in/${elem.url}`}
                    alt=""
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        ) : (
          <></>
        )}
      </div>
      <div className="information">
        <Info1 />
        <Info2 />
        <Info3 />
        <Info4 />
        <Info5 />
      </div>
      <footer>
        Code of Conduct | All Rights Reserved | IIIT ALLAHABAD | ©2022
      </footer>
    </div>
  );
};

export default Home;
